import type { TourStep } from '@components/tours/types';
import { resolveVisibleElement } from './resolveVisibleElement';

export const buildDriverSteps = (steps: TourStep[]) => {
  return steps.map(({ tourId, popover, ...rest }) => ({
    ...rest,
    element: resolveVisibleElement(`[data-tour-id="${tourId}"]`),
    popover: {
      title: popover?.title || '',
      description: popover?.description || '',
      ...popover,
    },
  }));
};
